module.exports = __webpack_public_path__ + "static/media/yuan6.e8cc8c36.png";